<template>
    <ul class="lee-menu-tree">
      <slot></slot>
    </ul>
</template>
<script>
export default {
    name: 'LeeMenuTree',
    inheritAttrs: false,
    data() {
        return {
        }
    },
    watch: {
    },
    mounted() {

    },
    methods: {
    },
    computed: {

    },
    props: {
    }
};
</script>
<style scoped>
.lee-menu-tree{background: #fff}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeMenuTree.vue